import { useEffect, useState } from 'react';

export const useResizeObserverByElementId = (id: string) => {
	const [resize, setResize] = useState({
		width: 0,
		height: 0,
	});

	useEffect(() => {
		const div = document.getElementById(id);

		if (!div) return;

		const resizeObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				setResize({
					width: entry.contentRect.width,
					height: entry.contentRect.height,
				});
			});
		});

		resizeObserver.observe(div);

		return () => {
			resizeObserver.unobserve(div);
		};
	}, [id]);

	return resize;
};
